import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';

import MdExpandLess from '@material-ui/icons/KeyboardArrowUp';
import MdExpandMore from '@material-ui/icons/KeyboardArrowDown';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';

export default function Group(props) {
  const Icon = props.expanded ? MdExpandLess : MdExpandMore;
  const contents = (
    <Fragment>
      {!!props.url && (
        <Link className="link-item-anchor" to={props.url}>
          <Typography className="link-item-text" component="h6">
            {props.title}
          </Typography>
        </Link>
      )}
      {!props.url && (
        <Typography className="link-item-text" component="h6">
          {props.title}
        </Typography>
      )}
      <IconButton
        onClick={props.onClick ? () => props.onClick(props.title) : null}
        disabled={props.active}
        className="link-item-icon"
        style={{
          visibility: props.onClick ? 'visible' : 'hidden',
        }}>
        <Icon />
      </IconButton>
    </Fragment>
  );

  return (
    <Div active={props.active} first={props.isFirst}>
      {!props.onClick && props.path ? (
        <Link className="link-item" to={props.path}>
          {contents}
        </Link>
      ) : (
        <Typography component="div" className="link-item">
          {contents}
        </Typography>
      )}
      {props.expanded && props.children}
    </Div>
  );
}

Group.propTypes = {
  title: PropTypes.string.isRequired,
  path: PropTypes.string,
  url: PropTypes.string,
  expanded: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  active: PropTypes.bool.isRequired,
  isFirst: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
};

Group.defaultProps = {
  path: '',
  url: '',
  onClick: () => {},
};

const Div = styled.div`
  ${props => (props.first ? 'margin-top: 8px;' : '')}

  .link-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-bottom: 0;
    padding: 8px 16px;
    padding-left: 0;
    border: 0;
    background: none;
    outline: none;
    cursor: pointer;
    text-decoration: none;

    .link-item-text,
    .link-item-anchor {
      flex-grow: 1;
    }

    .link-item-icon {
      flex-shrink: 0;
    }

    h6 {
      margin: 0;
      font-weight: ${props => (props.active ? 'bold' : 500)};
      letter-spacing: 2px;
      text-transform: capitalize;
      text-align: left;
      font-size: 18px;
      color: inherit;
    }

    svg {
      display: block;
      width: 20px;
      height: 20px;
      margin-left: auto;
      fill: currentColor;
    }

    &:not([disabled]) {
      cursor: pointer;
      &:hover {
        opacity: 0.8;
      }
    }
  }

  .link-item,
  .link-item-anchor {
    color: ${props => (props.active ? props.theme.colors.blue : props.theme.palette.text.primary)};
  }
`;
